import React,{useContext} from 'react';
import { 
  Box, Typography, TextField, FormControlLabel, Switch, 
  Radio, RadioGroup, FormControl, FormHelperText, Slider, Button
} from '@mui/material';
import Grid from './ContainerGrid'; 
import { useHistory } from 'react-router-dom';
import { NumericFormat } from 'react-number-format';

/*import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';*/
import ManagedDropdown from "./ManagedDropdown"

import moment from "moment";

import DateFilterInput from './DateFilterInput';
// IMPORT COMPONENT LOOKUP VỪA TẠO
import LookupFieldControl from './LookupFieldControl';
import OptimizedTextField from './OptimizedTextField';

import RickTextEditor from './HtmlEditor2';
import CodeEditor from './CodeEditor';
import JsonObjectControl from './JsonObjectControl';
import DynamicValueControl from './DynamicValueControl';

import Dashboard from './DynamicDashboard';
import AuthContext from "./auth/Context"; 

// IMPORT COMPONENT MẢNG LỒNG NHAU
import ObjectArrayControl from './ObjectArrayControl';

const EMPTY_ARRAY = [];

export default function BaseFieldControl({
  field, value, onChange, error, isReadOnly, formData = {}, masterData,
  formErrors = {}, // Thêm props formErrors để truyền xuống ObjectArrayControl
  formFields // danh sách TOÀN BỘ field của form hiện tại (truyền cho các script điều khiển UI)
}) {
  const context = useContext(AuthContext);
  const history = useHistory();
  // CHUYỂN GIAO TOÀN BỘ QUYỀN LỰC CHO LOOKUP COMPONENT
  if (field.type === 'Select' || field.type === 'Autocomplete') {
      let safeValue = value;
      if (value === undefined || value === null) {
          safeValue = field.multiple ? EMPTY_ARRAY : '';
      }
      return (
         <LookupFieldControl
            field={field} value={safeValue} onChange={onChange}
            error={error} isReadOnly={isReadOnly} formData={formData} masterData={masterData||formData} formFields={formFields}
         />
      );
  }

  // ================= CÁC FIELD CÒN LẠI (GIỮ NGUYÊN) =================
  let helperTextStr = error || field.helpText || '';
  // Gợi ý "Tối đa N ký tự" chỉ NỐI THÊM vào helpText đã có, KHÔNG tự sinh ra dòng chú thích cho field
  // vốn không khai helpText — cả form chứng từ mà field nào cũng có một dòng chữ mờ bên dưới thì rối,
  // và nó còn đội chiều cao của phần master lên.
  if (!error && field.maxLength && helperTextStr) helperTextStr = `${helperTextStr} (Tối đa ${field.maxLength} ký tự)`;
  if(typeof(helperTextStr) == "function"){
    helperTextStr = helperTextStr(context,formData,masterData||formData,formFields);
  }


  // ================= 2. NÂNG CẤP XỬ LÝ DATE & DATETIME BẰNG MUI PICKERS =================
  if (field.type === 'Date' || field.type === 'DateTime') {
      // Ép kiểu giá trị truyền vào thành đối tượng dayjs (nếu rỗng thì là null để UI không báo lỗi Invalid Date)
      const parsedValue = value ? moment(value) : null;
      
      // Các Props dùng chung để đồng bộ giao diện với TextField
      const commonSlotProps = {
          textField: {
              size: 'small',
              fullWidth: true,
              required: field.required,
              error: !!error,
              helperText: helperTextStr,
              InputProps: { readOnly: isReadOnly },
              sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', bgcolor: isReadOnly ? 'action.hover' : 'transparent' } }
          }
      };

      if (field.type === 'DateTime') {
          return (
              <ManagedDropdown type="datetimepicker"
                  label={field.label}
                  value={parsedValue}
                  readOnly={isReadOnly}
                  format="DD/MM/YYYY HH:mm"
                  onChange={(newValue) => {
                      if (newValue) {
                        //console.log("[basefiledcontroller] datetime change",newValue,newValue.toDate());
                        onChange(newValue.toDate?newValue.toDate():newValue);
                      } else {
                        onChange(null);
                      }
                  }}
                  slotProps={commonSlotProps}
              />
          );
      }
      if (field.type === 'Time') {
          return (
              <ManagedDropdown type="timepicker"
                  label={field.label}
                  value={parsedValue}
                  readOnly={isReadOnly}
                  format="HH:mm"
                  ampm={false} // Hiển thị chuẩn 24h
                  onChange={(newValue) => {
                      if (newValue) {
                          onChange(newValue.toDate?newValue.toDate():newValue);
                      } else {
                          onChange(null);
                      }



                  }}
                  slotProps={commonSlotProps}
              />
          );
      }

      return (
          <ManagedDropdown type="datepicker" 
              label={field.label}
              value={parsedValue}
              readOnly={isReadOnly}
              format="DD/MM/YYYY"
              onChange={(newValue) => {
                  if (newValue) {
                    //console.log("[basefiledcontroller] Date changed",{newValue,date:newValue.toDate()});
                    onChange(newValue.toDate?newValue.toDate():newValue);
                  } else {
                    onChange(null);
                  }
              }}
              slotProps={commonSlotProps}
          />
      );
  }

  if (field.type === 'Boolean') {
    return (
      <FormControlLabel control={<Switch disabled={isReadOnly} checked={!!value} onChange={(e) => onChange(e.target.checked)} color="primary" />} label={<Box><Typography fontWeight="500" variant="body2">{field.label} {field.required && <span style={{color:'red'}}>*</span>}</Typography>{helperTextStr && <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'}>{helperTextStr}</Typography>}</Box>} />
    );
  }
  const optionsList = field.options || [];

  if (field.type === 'Radio') {
    return (
      <FormControl error={!!error} disabled={isReadOnly} fullWidth>
        <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'} sx={{ fontWeight: 'bold', mb: 0.5, ml: 1 }}>{field.label} {field.required && <span style={{color:'red'}}>*</span>}</Typography>
        <RadioGroup row={field.row !== false} value={value || ''} onChange={(e) => onChange(e.target.value)} sx={{ ml: 1 }}>
          {optionsList.map(opt => <FormControlLabel key={opt.value} value={opt.value} control={<Radio size="small" />} label={<Typography variant="body2">{opt.label}</Typography>} />)}
        </RadioGroup>
        {helperTextStr && <FormHelperText sx={{ mx: 1.5 }}>{helperTextStr}</FormHelperText>}
      </FormControl>
    );
  }

  if (field.type === 'Slider') {
    return (
      <FormControl fullWidth error={!!error} disabled={isReadOnly}>
        <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'} sx={{ fontWeight: 'bold', mb: 3, ml: 1 }}>{field.label} {field.required && <span style={{color:'red'}}>*</span>}</Typography>
        <Box sx={{ px: 2 }}>
          <Slider value={value !== undefined && value !== '' ? value : (field.min || 0)} onChange={(e, newValue) => onChange(newValue)} valueLabelDisplay="on" min={field.min || 0} max={field.max || 100} step={field.step || 1} marks={field.marks} disableSwap />
        </Box>
        {helperTextStr && <FormHelperText sx={{ mx: 1.5, mt: -1 }}>{helperTextStr}</FormHelperText>}
      </FormControl>
    );
  }

  if (field.type === 'Number') {
    return (
      <OptimizedTextField 
        isNumeric={true}
        numericProps={{
            thousandSeparator: ".",
            decimalSeparator: ",",
            allowNegative: field.min !== undefined ? field.min < 0 : true,
            inputProps: { inputMode: 'decimal', pattern: '[0-9]*' }
        }}
        fullWidth size="small" label={field.label} required={field.required} error={!!error} helperText={helperTextStr} 
        value={value} 
        onChange={onChange} // Giao toàn quyền cho OptimizedTextField xử lý delay
        InputProps={{ readOnly: isReadOnly }} 
        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px', bgcolor: isReadOnly ? 'action.hover' : 'transparent' } }} 
      />
    );
  }

  if (field.type === 'NumberRange') {
    const isSlider = !!field.slider;
    const safeValue = value || { min: '', max: '' };
    return (
      <FormControl fullWidth error={!!error} disabled={isReadOnly}>
        <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'} sx={{ fontWeight: 'bold', mb: isSlider ? 3 : 0.5, ml: 1, display: 'block' }}>{field.label} {field.required && <span style={{color:'red'}}>*</span>}</Typography>
        {isSlider ? (
          <Box sx={{ px: 2 }}><Slider value={[safeValue.min !== '' && safeValue.min !== undefined ? Number(safeValue.min) : (field.min || 0), safeValue.max !== '' && safeValue.max !== undefined ? Number(safeValue.max) : (field.max || 100)]} onChange={(e, newValue) => onChange({ min: newValue[0], max: newValue[1] })} valueLabelDisplay="on" min={field.min || 0} max={field.max || 100} step={field.step || 1} marks={field.marks} disableSwap /></Box>
        ) : (
          <Grid container spacing={1.5}>
            <Grid size={{ xs: 6 }}><NumericFormat customInput={TextField} fullWidth size="small" placeholder="Từ..." value={safeValue.min !== undefined ? safeValue.min : ''} thousandSeparator="." decimalSeparator="," onValueChange={(vals) => onChange({ ...safeValue, min: vals.value })} InputProps={{ readOnly: isReadOnly }} sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px', bgcolor: isReadOnly ? 'action.hover' : 'transparent' } }} /></Grid>
            <Grid size={{ xs: 6 }}><NumericFormat customInput={TextField} fullWidth size="small" placeholder="Đến..." value={safeValue.max !== undefined ? safeValue.max : ''} thousandSeparator="." decimalSeparator="," onValueChange={(vals) => onChange({ ...safeValue, max: vals.value })} InputProps={{ readOnly: isReadOnly }} sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px', bgcolor: isReadOnly ? 'action.hover' : 'transparent' } }} /></Grid>
          </Grid>
        )}
        {helperTextStr && <FormHelperText sx={{ mx: 1.5, mt: isSlider ? -1 : 0.5 }}>{helperTextStr}</FormHelperText>}
      </FormControl>
    );
  }

  if (field.type === 'DateFilter') {
    const today = new Date();
    const safeValue = value || { type: 'all', year: today.getFullYear(), month: today.getMonth() + 1, fromDate: '', toDate: '' };
    return (
      <FormControl fullWidth error={!!error} disabled={isReadOnly}>
        <DateFilterInput label={field.label} mapTo={field.mapTo} value={safeValue} onChange={onChange} isReadOnly={isReadOnly} />
        {helperTextStr && <FormHelperText sx={{ mx: 1.5, mt: 0.5 }}>{helperTextStr}</FormHelperText>}
      </FormControl>
    );
  }

  if (field.type === 'RichText') {
    return (
      <FormControl fullWidth error={!!error} disabled={isReadOnly}>
        <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'} sx={{ fontWeight: 'bold', mb: 0.5, ml: 1, display: 'block' }}>{field.label} {field.required && <span style={{color:'red'}}>*</span>}</Typography>
        <RickTextEditor helperText={helperTextStr}  data={value} onChange={(e,data)=>{
          onChange(data);
        }} readOnly={isReadOnly}/>
        
      </FormControl>
    );
  }
  if (field.type === 'Code') {
    // Code editor chỉ hiển thị được chuỗi. Nếu value là object/array → stringify (đẹp) để hiện được.
    const codeValue = (value !== null && typeof value === 'object') ? JSON.stringify(value, null, 2) : value;
    return (
      <FormControl fullWidth error={!!error} disabled={isReadOnly}>
        <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'} sx={{ fontWeight: 'bold', mb:0.5, ml: 1, display: 'block' }}>{field.label} {field.required && <span style={{color:'red'}}>*</span>}</Typography>
        <CodeEditor helperText={helperTextStr} data={codeValue} onChange={(e,data)=>{
          onChange(data);
        }} readOnly={isReadOnly}/>
      </FormControl>
    );
  }
  if (field.type === 'Action' && field.actionScript && typeof(field.actionScript)=="function") {
    return (
      <Button 
        variant="outlined" 
        size="small" 
        color="primary"
        sx={{ textTransform: 'none', mt: 0.5 }}
        onClick={(e) => {
          e.stopPropagation();
          field.actionScript(context, formData, history, masterData||formData, formFields);
        }}
      >
        {field.label || 'Thực thi'}
      </Button>
    );
  }

  if (field.type === 'Dashboard') {
    return (
      <FormControl fullWidth error={!!error} disabled={isReadOnly}>
        <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'} sx={{ fontWeight: 'bold', mb:0.5, ml: 1, display: 'block' }}>{field.label} {field.required && <span style={{color:'red'}}>*</span>}</Typography>
        <Dashboard dfWidgets={value || []} gridLayoutMode="fixed" onChange={(e,data)=>{
          onChange(data);
        }} readOnly={isReadOnly} hideHeader={true} containerSx={{minHeight:"300px",borderRadius:3}}/>
        {helperTextStr && <FormHelperText sx={{ mx: 1.5, mt: 0.5 }}>{helperTextStr}</FormHelperText>}
      </FormControl>
    );
  }
  if (field.type === 'Mixed') {
    return (
      <FormControl fullWidth error={!!error} disabled={isReadOnly}>
        <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'} sx={{ fontWeight: 'bold', mb:0.5, ml: 1, display: 'block' }}>{field.label} {field.required && <span style={{color:'red'}}>*</span>}</Typography>
        <DynamicValueControl data={value} onChange={(e,data)=>{
          onChange(data);
        }} isReadOnly={isReadOnly} defaultType={field.defaultType}/>
        {helperTextStr && <FormHelperText sx={{ mx: 1.5, mt: 0.5 }}>{helperTextStr}</FormHelperText>}
      </FormControl>
    );
  }


  if (field.type === 'Object') {
    return (
      <FormControl fullWidth error={!!error} disabled={isReadOnly}>
        <Typography variant="caption" color={error ? 'error.main' : 'text.secondary'} sx={{ fontWeight: 'bold', mb:0.5, ml: 1, display: 'block' }}>{field.label} {field.required && <span style={{color:'red'}}>*</span>}</Typography>
        <JsonObjectControl helperText={helperTextStr} data={value} onChange={(e,data)=>{
          onChange(data);
        }} isReadOnly={isReadOnly}/>
      </FormControl>
    );
  }

  // ================= TÍCH HỢP OBJECT ARRAY CONTROL =================
  if (field.type === 'ObjectArray' || field.type === 'Array') {
    return (
      <FormControl fullWidth>
         {/* ObjectArrayControl đã tự render label và xử lý lỗi bên trong */}
         <ObjectArrayControl
            field={field}
            value={value}
            onChange={onChange} // Form builder/Core đã xử lý dạng callback trực tiếp
            formErrors={formErrors} // Truyền toàn bộ object lỗi để tự bóc tách lỗi chi tiết
            isReadOnly={isReadOnly}
            masterData={formData} // Với mảng con, "mẹ" là chính bản ghi hiện tại (formData)
         />
         {helperTextStr && <FormHelperText sx={{ mx: 1.5, mt: 0.5 }}>{helperTextStr}</FormHelperText>}
      </FormControl>
    );
  }

  return (
    <OptimizedTextField 
      fullWidth size="small" label={field.label} 
      type={field.type === 'Date' ? 'date' : 'text'} 
      required={field.required} error={!!error} helperText={helperTextStr} 
      InputLabelProps={field.type === 'Date' ? { shrink: true } : {}} 
      multiline={field.multiline} rows={field.multiline ? 3 : 1} 
      inputProps={{ maxLength: field.maxLength }} 
      InputProps={{ readOnly: isReadOnly }} 
      
      value={value} 
      onChange={onChange}
      
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: field.multiline ? '10px' : '8px', bgcolor: isReadOnly ? 'action.hover' : 'transparent' } }} 
    />
  );
}